export function errorWithNothingCachedToShow<TData, TError>(
  data: TData | undefined,
  error: TError | null
): TError | null {
  return data === undefined ? error : null;
}
